import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Add effect to prevent scrolling when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      // Close mobile menu after navigation
      setIsMobileMenuOpen(false);
    }
  };
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  return <motion.header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'shadow-sm py-4' : 'bg-transparent py-6'}`} style={{
    backgroundColor: isScrolled ? '#F4F6ED' : 'transparent'
  }} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-126">
      <div className="container mx-auto px-6 md:px-12 max-w-6xl flex justify-between items-center" data-id="element-127">
        <div className="pl-0 md:pl-0" data-id="element-128">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fr2VGgh1ZwdPD1wi33YLWH/davood_torabzadeh_pencil_transparent.png" alt="Davood Torabzadeh" className="h-5 md:h-6 w-auto" data-id="element-129" />
        </div>
        <nav className="hidden md:block" data-id="element-130">
          <ul className="flex space-x-10" data-id="element-131">
            <li data-id="element-132">
              <button onClick={() => scrollToSection('services')} className="text-ink-800 hover:text-ink-500 transition-colors text-sm tracking-wide font-currency" data-id="element-133">
                Services
              </button>
            </li>
            <li data-id="element-134">
              <button onClick={() => scrollToSection('work')} className="text-ink-800 hover:text-ink-500 transition-colors text-sm tracking-wide font-currency" data-id="element-135">
                Work
              </button>
            </li>
            <li data-id="element-136">
              <button onClick={() => scrollToSection('about')} className="text-ink-800 hover:text-ink-500 transition-colors text-sm tracking-wide font-currency" data-id="element-137">
                About
              </button>
            </li>
            <li data-id="element-138">
              <button onClick={() => scrollToSection('writing')} className="text-ink-800 hover:text-ink-500 transition-colors text-sm tracking-wide font-currency" data-id="element-139">
                Writing
              </button>
            </li>
            <li data-id="element-140">
              <button onClick={() => scrollToSection('contact')} className="text-ink-800 hover:text-ink-500 transition-colors text-sm tracking-wide font-currency" data-id="element-141">
                Contact
              </button>
            </li>
          </ul>
        </nav>
        <button className="md:hidden text-ink-800 z-50" onClick={toggleMobileMenu} aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-142">
          {isMobileMenuOpen ? <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-143">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-144" />
            </svg> : <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-145">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" data-id="element-146" />
            </svg>}
        </button>
      </div>
      {/* Mobile Menu */}
      <AnimatePresence data-id="element-147">
        {isMobileMenuOpen && <motion.div className="fixed inset-0 bg-parchment-50 z-40 md:hidden" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-148">
            <motion.div className="h-full flex flex-col pt-24 pb-12 px-8" style={{
          backgroundColor: '#F4F6ED'
        }} initial={{
          y: -20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} exit={{
          y: -20,
          opacity: 0
        }} transition={{
          delay: 0.1,
          duration: 0.3
        }} data-id="element-149">
              <nav className="flex-1" data-id="element-150">
                <ul className="space-y-8 flex flex-col items-center justify-center h-full" data-id="element-151">
                  <motion.li initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: 0.2
              }} data-id="element-152">
                    <button onClick={() => scrollToSection('services')} className="text-ink-800 hover:text-ink-500 transition-colors text-xl tracking-wide font-currency" data-id="element-153">
                      Services
                    </button>
                  </motion.li>
                  <motion.li initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: 0.3
              }} data-id="element-154">
                    <button onClick={() => scrollToSection('work')} className="text-ink-800 hover:text-ink-500 transition-colors text-xl tracking-wide font-currency" data-id="element-155">
                      Work
                    </button>
                  </motion.li>
                  <motion.li initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: 0.4
              }} data-id="element-156">
                    <button onClick={() => scrollToSection('about')} className="text-ink-800 hover:text-ink-500 transition-colors text-xl tracking-wide font-currency" data-id="element-157">
                      About
                    </button>
                  </motion.li>
                  <motion.li initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: 0.5
              }} data-id="element-158">
                    <button onClick={() => scrollToSection('writing')} className="text-ink-800 hover:text-ink-500 transition-colors text-xl tracking-wide font-currency" data-id="element-159">
                      Writing
                    </button>
                  </motion.li>
                  <motion.li initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: 0.6
              }} data-id="element-160">
                    <button onClick={() => scrollToSection('contact')} className="text-ink-800 hover:text-ink-500 transition-colors text-xl tracking-wide font-currency" data-id="element-161">
                      Contact
                    </button>
                  </motion.li>
                </ul>
              </nav>
              <div className="mt-auto mx-auto opacity-30" data-id="element-162">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fr2VGgh1ZwdPD1wi33YLWH/davood_torabzadeh_pencil_transparent.png" alt="Davood Torabzadeh" className="h-3.5 w-auto" data-id="element-163" />
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </motion.header>;
}